


























































import ApiClient from '@/services/api-client'
import { Component, Vue, Watch } from 'vue-property-decorator'
import Utils from '@/utils'
import { AssetsResponse, AssetData } from '@/models'

@Component({
  components: {
    DownloadButton: () => import('@/components/DownloadButton.vue')
  }
})
export default class Assets extends Vue {
  private search = ''
  private productId = this.$route.params.productId
  private workModuleCode = this.$route.params.workModuleCode
  private assetsList: AssetsResponse = { assets: [] }

  get filteredItems() {
    const searchText = this.search.toLowerCase()

    const filtered: any = {}
    for (const [key, value] of Object.entries(this.assetsList)) {
      const filteredValues = value.filter((item) => {
        return item.name.toLowerCase().indexOf(searchText) > -1
      })
      if (filteredValues.length) {
        filtered[key] = filteredValues
      }
    }
    return filtered
  }

  created() {
    this.loadAssets()
  }

  mounted() {
    this.setPageTitle()
  }

  private getSize(asset: AssetData) {
    return Utils.bytesToSize(asset.size)
  }

  private loadAssets() {
    if (this.productId && this.workModuleCode) {
      ApiClient.getWorkModuleAssets(this.productId, this.workModuleCode).then(
        (response) => {
          this.assetsList = response
        }
      )
    }
  }

  @Watch('$store.state.activeProduct')
  setPageTitle() {
    const product = this.$store.state.activeProduct
    const workModule = Utils.getCurrentWorkModule(
      product,
      this.$route.params.workModuleCode
    )

    if (workModule) {
      window.document.title = `${this.$i18n.t('pageTitle.assets')} ${
        product.title
      } / ${workModule?.title} - LDX`
    }
  }
}
